export const loginOtpConstants = {
  LOGINOTP_API: "/vendor/send-otp",
  VERIFYOTP_API: "/vendor/verify-otp",
};
